import { useRole } from './index';

export const useReadOnly = () => {
  const role = useRole();

  return role == 'read';
};
